module.exports = __webpack_public_path__ + "img/question-title-tablet.41e4d872.png";